export const  LedgerSortEnum =Object.freeze(
   {
      Latest:0,
      Amount:1
   })